import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const DeleteTicketPriorityType = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const hideModal = () => {
		props.onHide();
	};

	const deleteBtnOnClick = () => {
		DeleteTicketPriorityType(props.editData);
	};

    const DeleteTicketPriorityType = (_data) => {
		let functionName = "";

		try {
			functionName = props.page + DeleteTicketPriorityType.name;

			props.onLoading(true, "Deleting ticket priority type, please wait...");
			props.onHide();

			const data = {
				TICKET_PRIORITY_TYPE_ID: _data.TICKET_PRIORITY_TYPE_ID,
				TICKET_PRIORITY_TYPE_NAME: _data.TICKET_PRIORITY_TYPE_NAME,
			    UPDATE_ID: userId,
			    FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.put("api/TicketPriorityType/DeleteTicketPriorityType", data, { timeout: 5000 })
				.then(() => {
					toast.success("Ticket priority type is successfully deleted.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to delete ticket priority type. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to delete ticket priority type. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const message = (
		<>
			Confirm to delete?
			<br />
			Ticket Priority Type :
			{<b> {props.editData !== null && props.editData.TICKET_PRIORITY_TYPE_NAME}</b>}
		</>
	);

	return (
		<>
			<Comp.ConfirmModal
				show={props.showHide}
				onHide={hideModal}
				onConfirm={deleteBtnOnClick}
				delete
			>
				{message}
			</Comp.ConfirmModal>
		</>
	);

};

export default DeleteTicketPriorityType;